export const rateCardRoute = '/rate-cards';
export const newRateCardRoute = '/rate-cards/new';
export const getRateCardIdRoute = (rateCardId: string) => `/rate-cards/${rateCardId}`;
